var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("div", { staticClass: "disp-flex" }, [
        _c("div", { staticClass: "mb-20" }, [
          _c("h1", { staticClass: "mt-0" }, [
            _vm._v(_vm._s(_vm.$t("settings")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _vm.env === "development"
            ? [
                _c("el-alert", [
                  _c("h3", [_vm._v("For Development")]),
                  _vm._v(" "),
                  _c("section", [
                    _c(
                      "div",
                      { staticClass: "mb-10" },
                      [
                        _c("p", [_vm._v("Refresh token")]),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.requestNewToken }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\tRequest New Token\n\t\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "section",
                    [
                      _c("p", [_vm._v("Grapesjs")]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({ name: "grapesjs" })
                            }
                          }
                        },
                        [_vm._v("Go to Grapesjs Sandbox")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("section", [
                    _c("h3", [_vm._v("Timetravel")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("div", [
                          _c("h5", [_vm._v(_vm._s(_vm.$t("currentTime")))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-10" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.currentTime) +
                                "\n\t\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("h5", [
                          _vm._v(_vm._s(_vm.$t("setNewTime"))),
                          _c("sup", [_vm._v("dev")])
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form",
                          {
                            ref: "timingForm",
                            attrs: {
                              model: _vm.timingForm,
                              "label-position": "top",
                              inline: true,
                              size: "mini"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    format: "dd-MM-yyyy HH:mm",
                                    type: "datetime",
                                    placeholder: _vm.$t("chooseTimestamp"),
                                    "picker-options": _vm.pickerOptions
                                  },
                                  model: {
                                    value: _vm.timingForm.timeStamp,
                                    callback: function($$v) {
                                      _vm.$set(_vm.timingForm, "timeStamp", $$v)
                                    },
                                    expression: "timingForm.timeStamp"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.submitForm("timingForm")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("confirmTimeTravel")) +
                                        " "
                                    ),
                                    _c(
                                      "i",
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            "icon-class": "rocket-solid"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "warning" },
                                    on: { click: _vm.resetTime }
                                  },
                                  [
                                    _vm._v("Reset "),
                                    _c(
                                      "i",
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "undo-solid" }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "mb-20" })
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("section", [
            _c("div", [
              _c("div", { staticClass: "mb-10" }, [
                _c("h3", [_vm._v("Force send")]),
                _vm._v("\n\t\t\t\t\t\tWill force send: "),
                _c("b", [_vm._v(_vm._s(_vm.forceSend))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-15" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.toggleForceSend }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\tToggle force send\n\t\t\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("hr", { staticClass: "mb-20" }),
          _vm._v(" "),
          _c(
            "section",
            [
              _c("h3", [_vm._v("UI & UX")]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-10" }, [
                _vm._v(_vm._s(_vm.$t("themeColor")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("theme-picker", {
                    staticStyle: { height: "26px", margin: "-3px 8px 0 0" },
                    on: { change: _vm.themeChange }
                  }),
                  _vm._v(" "),
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("test")
                  ]),
                  _vm._v(" "),
                  _c("el-button", { attrs: { type: "success" } }, [
                    _vm._v("test")
                  ]),
                  _vm._v(" "),
                  _c("el-button", { attrs: { type: "warning" } }, [
                    _vm._v("test")
                  ]),
                  _vm._v(" "),
                  _c("el-button", { attrs: { type: "danger" } }, [
                    _vm._v("test")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-10" }, [
                _vm._v(_vm._s(_vm.$t("fixedHeader")))
              ]),
              _vm._v(" "),
              _c("el-switch", {
                staticClass: "drawer-switch",
                model: {
                  value: _vm.fixedHeader,
                  callback: function($$v) {
                    _vm.fixedHeader = $$v
                  },
                  expression: "fixedHeader"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mb-10" }, [
                _vm._v(_vm._s(_vm.$t("sidebarLogo")))
              ]),
              _vm._v(" "),
              _c("el-switch", {
                staticClass: "drawer-switch",
                model: {
                  value: _vm.sidebarLogo,
                  callback: function($$v) {
                    _vm.sidebarLogo = $$v
                  },
                  expression: "sidebarLogo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "mb-20 mt-20" }),
          _vm._v(" "),
          _c(
            "section",
            [
              _c("json-editor", {
                ref: "jsonEditor",
                model: {
                  value: _vm.jsonData,
                  callback: function($$v) {
                    _vm.jsonData = $$v
                  },
                  expression: "jsonData"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("section", [
            _c("b", [_vm._v("TinyMCE API Key")]),
            _vm._v(" "),
            _c("br"),
            _vm._v("\n\t\t\t\t" + _vm._s(_vm.apiKey) + "\n\t\t\t\t")
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }